import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { E as u, S as f } from "./icons.types-0722eef5.js";
function v({ title: e, titleId: r, size: o, width: h, height: n, extended: i = !1, ...s }) {
  const t = i ? u : f, c = o ? t[o] : h || t[i ? "s" : "l"], d = o ? t[o] : n || t[i ? "s" : "l"];
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: c,
      height: d,
      "aria-labelledby": r,
      ...s,
      children: [
        e ? /* @__PURE__ */ l("title", { id: r, children: e }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Bluetooth_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M32.057 28.877 31.966 0l19.62 21.41-13.183 14.128 13.592 14.264L32.194 72l-.096-29.709-9.083 9.744-3.515-3.279 12.296-13.181L19.54 22.712l3.48-3.317 9.037 9.482Zm4.844 12.054.06 18.5 8.492-9.522-8.552-8.978Zm-.092-28.53.055 17.735 8.172-8.758-8.227-8.977Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Bluetooth_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  v as Bluetooth
};
